@if (loaderService.loadingCount() > 0) {
  <div class="fixed left-1/2 top-1/2 py-3 px-5 shadow-2 bg-white loader rounded-md">
    <app-spinner></app-spinner>
  </div>
}
